import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Layout del módulo Formación (LAE).
 *
 * Mismo criterio que InventarioLayout: NO renderiza sidebar propio. La
 * intranet ya tiene su franja gris global (`<ul className="lista
 * lista-secundaria">` en Sidebar.js), que es donde vive el submenú del
 * módulo (FormacionSidebar, montado por Sidebar.js cuando numbtn === 11).
 *
 * El padding/fondo del contenido los pone cada página (px-6 py-5 sobre
 * bg-slate-50), siguiendo el patrón DS v2.
 */
export default function FormacionLayout() {
  return <Outlet />;
}
